<template>
    <div class="eval-page">
        <!-- 悬浮返回按钮 -->
        <div class="float-back-btn" @click="goBack">
            <span class="back-icon">←</span>
            <span class="back-label">返回列表</span>
        </div>

        <!-- iframe容器 -->
        <div ref="iframeWrap" class="iframe-container"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframeUrl: '', // 测评页面完整URL
        };
    },
    created() {
        // 拼接中科新测评系统地址（对应 uniapp 的 onLoad(options)，scale 从路由 query 获取）
        // user 为测评系统用户标识，当前用 demo 账号，后续接入正式用户后可替换为登录用户ID/手机号
        const baseUrl = 'https://evaluatetest.zhongkexintu.net/demo/detail.html';
        const scale = this.$route.query.scale || 'SDS';
        this.iframeUrl = `${baseUrl}?user=demo_test_user&scale=${scale}`;
    },
    mounted() {
        this.$nextTick(() => {
            this.createIframe();
        });
    },
    methods: {
        /**
         * 创建iframe加载测评页面
         */
        createIframe() {
            if (!this.iframeUrl) return;
            const wrap = this.$refs.iframeWrap;
            if (!wrap) return;
            const iframe = document.createElement('iframe');
            iframe.src = this.iframeUrl;
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            wrap.appendChild(iframe);
        },

        /**
         * 返回门户列表页
         */
        goBack() {
            this.$router.replace('/portal');
        },
    },
};
</script>

<style lang="scss" scoped>
.eval-page {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}

/* ==================== 悬浮返回按钮 ==================== */
.float-back-btn {
    position: fixed;
    top: 30rpx;
    left: 24rpx;
    z-index: 99999;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 40rpx;
    padding: 14rpx 28rpx;
    cursor: pointer;
    box-shadow: 0 4rpx 20rpx rgba(0, 0, 0, 0.15), 0 2rpx 8rpx rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:active {
        transform: scale(0.95);
        box-shadow: 0 2rpx 10rpx rgba(0, 0, 0, 0.1);
    }
}

.back-icon {
    font-size: 32rpx;
    color: #e8735a;
    font-weight: 600;
    margin-right: 8rpx;
}

.back-label {
    font-size: 26rpx;
    color: #3d2c2c;
    font-weight: 500;
}

/* ==================== iframe容器 ==================== */
.iframe-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
